export default __webpack_public_path__ + "static/media/image-ph-health-statistics-w@3x.c5ad2c74.webp";